<template>
  <div class="el-form-item item subform certificate">
    <label for="time" class="el-form-item__label" :style="labelWidth ? `width: ${labelWidth}` : ''">
      {{ config.label }}
    </label>
    <div class="el-form-item__content">
      <div class="content">
        <FormItem v-for="(c, i) in formCtrls" :key="'formItem' + i" :viewMode="viewMode" :config="c"
          :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

        <FormItemRemind :config="remindCtrl" :options1="options1" :options2="options2"
          :inputValue="form[remindCtrl.key1]" :inputValue2="form[remindCtrl.key2]" :viewMode="viewMode"
          :labelWidth="labelWidth" @onChange="onChange" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Certificate",
  props: {
    labelWidth: String,
    config: Object,
    form: Object,
    formCtrls: Array,
    viewMode: Boolean,
    remindCtrl: Object,
    options1: Array,
    options2: Array,
  },
  data() {
    return {};
  },
  methods: {
    onChange({ key, value }) {
      // console.log(key, value)
      this.$emit("onChange", {
        key,
        value,
        data: (this.config && this.config.data),
      });
    },
  },
};
</script>

<style lang="less" scoped>
// .el-form-item {
//   &.subform/deep/ {
//     >.el-form-item__content {
//       margin-left: 180px;

//       >.content {
//         .el-form-item {
//           margin-bottom: 18px;
//         }
//       }
//     }
//   }
// }
</style>
